export default {
  namespaced: true,
  state: {
    showAddTaskDialog: false, // 新增任务弹窗
    showTaskDetailDialog: false, // 任务详情弹窗
    showEditTaskDialog: false, // 编辑弹窗状态
    currentTaskId: null,
    editTaskData: { // 新增编辑任务数据
      id: null,
      name: '',
      page: null
    },
    mediaList: {
      hot_media: [],
      media_list: []
    },
    config: {
      adFormats: [
        { label: '信息流广告', value: 1 },
        { label: '原生广告', value: 2 },
        { label: '非原生广告', value: 3 },
        { label: '达人广告', value: 4 }
      ],
      materialTypes: [
        { label: '图片', value: 1 },
        { label: '视频', value: 2 }
      ],
      layoutOptions: [
        { label: '横版', value: 1 },
        { label: '竖版', value: 2 },
        { label: '方形', value: 3 }
      ],
      resolutionOptions: [
        { label: '标准(<700px)', value: 1 },
        { label: '高清(700px~1080px)', value: 2 },
        { label: '超高清(>1080px)', value: 3 }
      ],
      productAttributes: [
        { label: 'APP', value: 1 },
        { label: '微信小程序', value: 2 },
        { label: '抖音小程序', value: 3 },
        { label: '快应用', value: 4 },
        { label: '公众号', value: 5 },
        { label: '快手小程序', value: 6 }
      ],
      imageTypes: [
        { label: '单图', value: 1 },
        { label: '双图', value: 2 },
        { label: '三图', value: 3 },
        { label: '多图', value: 4 }
      ],
      sortByOptions: [
        { label: '最近出现', value: 1 },
        { label: '出现次数', value: 2 },
        { label: '最多计划使用', value: 3 },
        { label: '最多投放天数', value: 4 },
        { label: '最多曝光', value: 5 },
        { label: '最多转化', value: 6 },
        { label: '最多点赞', value: 7 },
        { label: '最多评论', value: 8 },
        { label: '最多分享', value: 9 },
        { label: '最多播放', value: 10 }
      ]
    }
  },
  getters: {
    adFormats: (state) => state.config.adFormats,
    materialTypes: (state) => state.config.materialTypes,
    layoutOptions: (state) => state.config.layoutOptions,
    resolutionOptions: (state) => state.config.resolutionOptions,
    productAttributes: (state) => state.config.productAttributes,
    imageTypes: (state) => state.config.imageTypes,
    sortByOptions: (state) => state.config.sortByOptions,
    showTaskDetailDialog: (state) => state.showTaskDetailDialog,
    showEditTaskDialog: (state) => state.showEditTaskDialog, // 获取编辑弹窗状态
    editTaskData: (state) => state.editTaskData, // 获取编辑任务数据
    currentTaskId: (state) => state.currentTaskId
  },
  mutations: {
    SET_SHOW_ADD_TASK_DIALOG(state, bool) {
      state.showAddTaskDialog = bool
    },
    SET_SHOW_TASK_DETAIL_DIALOG(state, bool) {
      state.showTaskDetailDialog = bool
    },
    SET_SHOW_EDIT_TASK_DIALOG(state, bool) { // 新增编辑弹窗状态管理
      state.showEditTaskDialog = bool
    },
    SET_CURRENT_TASK_ID(state, id) {
      state.currentTaskId = id
    },
    SET_EDIT_TASK_DATA(state, taskData) { // 新增设置编辑任务数据
      state.editTaskData = taskData
    },
    SET_MEDIA_LIST(state, mediaList) {
      state.mediaList = mediaList
    }
  },
  actions: {
    openAddTaskDialog({ commit }) {
      commit('SET_SHOW_ADD_TASK_DIALOG', true)
    },
    closeAddTaskDialog({ commit }) {
      commit('SET_SHOW_ADD_TASK_DIALOG', false)
    },
    openTaskDetailDialog({ commit }, id) {
      commit('SET_CURRENT_TASK_ID', id)
      commit('SET_SHOW_TASK_DETAIL_DIALOG', true)
    },
    closeTaskDetailDialog({ commit }) {
      commit('SET_SHOW_TASK_DETAIL_DIALOG', false)
      commit('SET_CURRENT_TASK_ID', null)
    },
    openEditTaskDialog({ commit }, taskData) { // 新增打开编辑弹窗
      commit('SET_EDIT_TASK_DATA', taskData)
      commit('SET_SHOW_EDIT_TASK_DIALOG', true)
    },
    closeEditTaskDialog({ commit }) { // 新增关闭编辑弹窗
      commit('SET_SHOW_EDIT_TASK_DIALOG', false)
      commit('SET_EDIT_TASK_DATA', { id: null, name: '', page: null })
    },
    async fetchMediaList({ commit }) {
      try {
        const { medialist } = await import('@/api/miniAd')
        const response = await medialist()
        commit('SET_MEDIA_LIST', {
          hot_media: response.data.hot_media || [],
          media_list: response.data.media_list || []
        })
      } catch (error) {
        console.error('获取媒体列表失败:', error)
        throw error
      }
    }
  }
}
